<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card :loading="loading" class="pa-2 rounded-lg ma-md-4" flat>
        <v-card-title class="flex-md-nowrap text-break pa-0 pa-md-4 white">
          <span class="pb-2">
            {{ value === undefined ? "ساخت" : "ویرایش" }}
            {{ computedValue.name }}
          </span>
          <v-spacer />
        </v-card-title>

        <div class="pa-md-4">
          <pic-selector
            :edit-img="false"
            :edit-name="false"
            :field.sync="computedValue.image"
            bracket="128"
            one-pic
            single
          />

          <v-row no-gutters>
            <v-col class="pa-2" cols="12" lg="4" md="6">
              <div class="rowinfo">
                <v-text-field
                  v-model="computedValue.name"
                  :rules="[rules.notEmpty, rules.minLen]"
                  clear-icon="mdi-close-circle-outline"
                  clearable
                  dense
                  label="عنوان"
                  outlined
                  class="contentinfo"
                />
                <help-info
                  :element-name="`${serviceName}-${componentName}-computedValue-name`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  label="عنوان"
                />
              </div>
            </v-col>

            <v-col class="pa-2" cols="12" lg="4" md="6">
              <div class="rowinfo">
                <price-input
                  v-model.number="computedValue.price"
                  class="mb-2 contentinfo"
                  dense
                  label="قیمت"
                />
                <help-info
                  :element-name="`${serviceName}-${componentName}-computedValue-price`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  label="قیمت"
                />
              </div>
            </v-col>

            <v-col class="pa-2" cols="12" lg="4" md="6">
              <div class="rowinfo">
                <v-text-field
                  v-model.number="computedValue.discount"
                  append-icon="mdi-percent"
                  clear-icon="mdi-close-circle-outline"
                  clearable
                  dense
                  label="تخفیف"
                  maxLength="3"
                  class="contentinfo"
                  outlined
                  type="number"
                />
                <help-info
                  :element-name="`${serviceName}-${componentName}-computedValue-discount`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  label="تخفیف"
                />
              </div>
            </v-col>

            <v-col class="pa-2" cols="12">
              <div class="rowinfo">
                <suggest-text
                  v-model="computedValue.description"
                  :hide-details="false"
                  label="توضیحات"
                  class="contentinfo"
                />
                <help-info
                  :element-name="`${serviceName}-${componentName}-computedValue-description`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  label="توضیحات"
                />
              </div>
            </v-col>
          </v-row>

          <v-divider />
          <div class="extra-wrapper">
            <v-expansion-panels>
              <v-expansion-panel class="mt-4">
                <v-expansion-panel-header>
                  <div
                    class="pa-2 d-flex row justify-start"
                    style="align-items: center"
                  >
                    ویژگی‌های محصول
                    <help-info
                      :element-name="`${serviceName}-${componentName}-feature-product`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="ویژگی‌های محصول"
                    />
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pa-2">
                  <extra-fileds v-model="computedValue.extra" block />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import PicSelector from "@/view/components/UploadCenter/picSelector";
import IconPicker from "@/view/components/IconPicker";
import PriceInput from "@/view/pages/uiBeautifier/priceInput";
import SuggestText from "@/view/components/SuggestBox/suggestInput";
import ExtraFileds from "./extraFileds";
import CallToAction from "@/view/components/CallToAction";
import ExtraSubProducts from "@/view/components/Product/extraSubProducts.vue";

export default {
  name: "singleProductEditor",

  components: {
    ExtraSubProducts,
    CallToAction,
    ExtraFileds,
    SuggestText,
    PriceInput,
    IconPicker,
    PicSelector,
  },

  props: {
    value: Object,
  },

  inject: ["productImageSize"],

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "single-product-editor",
      loading: false,
      status: "return",
      rules: {
        notEmpty: (v) => !!v?.length || "فیلد الزامی میباشد.",
        minLen: (v) => v?.length >= 3 || "حداقل طول فیلد ۳ حرف میباشد.",
      },
    };
  },

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    resetOther(product, name) {
      const current = product[name];

      product.gallery = [{ name: "", images: [] }];
      product.color = undefined;
      product.icon = undefined;

      product[name] = current;
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  border-bottom: 2px solid var(--v-primary-base);
}

.v-card >>> input::-webkit-outer-spin-button,
.v-card >>> input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.v-card >>> input[type="number"] {
  -moz-appearance: textfield;
}

.v-radio >>> label {
  top: 3px !important;
}

.extra-wrapper >>> .v-expansion-panel {
  border-radius: 15px !important;
  box-shadow: 8px 5px 10px #f49d1a;
}

.extra-wrapper
  >>> .v-expansion-panel
  .v-expansion-panel-header.v-expansion-panel-header--active {
  background-color: #001554 !important;
  border-radius: 15px !important;
  color: gray !important;
}

.extra-wrapper
  >>> .v-expansion-panel
  .v-expansion-panel-header.v-expansion-panel-header--active
  .v-icon {
  color: whitesmoke !important;
}

.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
  padding: 0;
}
</style>
